/**
 * The template sizes its logos through a `data-width` attribute that its own main.js
 * copies onto the element's inline width. Nothing in CSS reads the attribute, so without
 * this pass the logos render at their intrinsic SVG size instead of the design's.
 */
export function setupDataWidths(root: HTMLElement) {
  const restored = new Map<HTMLElement, string | null>();

  root.querySelectorAll<HTMLElement>('[data-width]').forEach((element) => {
    const width = element.dataset.width?.trim();
    if (!width) return;
    restored.set(element, element.getAttribute('style'));
    element.style.width = /^\d+(\.\d+)?$/.test(width) ? `${width}px` : width;
  });

  return () => {
    restored.forEach((style, element) => {
      if (style === null) element.removeAttribute('style');
      else element.setAttribute('style', style);
    });
  };
}
